import BaseEntity from './BaseEntity';
import { equalOutline } from '../math/utils';
import { RoomData } from '../data/room/Room';
import { EEntityType } from '../types';
import { isNumber } from 'lodash-es';
import { getPathFromEdges } from '../utils/edge';
import { IShapePoint2d } from '../types/shape';
import CeilModel from './3d/ceilModel';

export default class CeilEntity extends BaseEntity<EEntityType.Ceil> {
  private _path: IShapePoint2d[];
  private _height: number;
  protected override _model3d: CeilModel;

  constructor(roomData: RoomData) {
    super({
      id: roomData.id,
      type: EEntityType.Ceil
    });

    this._path = roomData.pathInfos.map((info) => info.start);
    this._height = roomData.height;
    this._model3d = new CeilModel(roomData);
  }

  override update(roomData: RoomData & { forceUpdate?: boolean }) {
    let needUpdate = false;

    if (roomData.pathInfos) {
      const path = getPathFromEdges(roomData.pathInfos);
      if (!equalOutline(path, this._path)) {
        this._path = path;
        needUpdate = true;
      }
    }

    if (isNumber(roomData.height) && roomData.height !== this._height) {
      this._height = roomData.height;
      needUpdate = true;
    }

    if (needUpdate || roomData.forceUpdate) {
      this._model3d.clearModel();
      this._model3d.createCeilModel(roomData);
    }
  }
}
